import {Configuration} from "@api-clients/runtime";
import {ProveCampaign} from "@api-clients/prove/schema/ProveCampaign";

export class FindAllProveCampaignsApi {

    static async execute(
        configuration: Configuration
    ): Promise<ProveCampaign[]> {
        const response = await fetch(`${configuration.basePath}/a360/v1/prove/campaigns`, {
            method: 'GET',
            headers: configuration.headers
        });

        return response.json();
    }

}
